var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boas-vindas-passo" }, [
    _c(
      "div",
      {
        staticClass:
          "boas-vindas-passo__cabecalho d-flex align-baseline az-gap-small"
      },
      [
        _c(
          "span",
          { staticClass: "boas-vindas-passo__numero ia-texto-titulo-cartao" },
          [_vm._v(_vm._s(_vm.passo.numero))]
        ),
        _c(
          "p",
          {
            staticClass:
              "boas-vindas-passo__titulo az-text-primary az-size-14 font-bold mb-0"
          },
          [_vm._v(" " + _vm._s(_vm.passo.titulo) + " ")]
        )
      ]
    ),
    _c(
      "p",
      { staticClass: "boas-vindas-passo__descricao az-ds-aux mt-1 mb-0" },
      [_vm._v(_vm._s(_vm.passo.descricao))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }